import { Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { FrontPageComponent } from "./routes/front-page/front-page.component";
import { ErrorPageComponent } from "./routes/error-page/error-page.component";
import { AuthGuard } from "./shared/services/auth-guard.guard";

export const routes: Routes = [
    {
        path: "",
        component: FrontPageComponent,
        title: "Forside"
    },
    {
        path: "videns-artikler",
        loadComponent: () =>
            import("./routes/knowledge-articles-overview-page/knowledge-articles-overview-page.component").then(
                (component) => component.KnowledgeArticlesOverviewPageComponent
            ),
        title: "Vidensartikler",
        canActivate: [AuthGuard]
    },
    {
        path: "videns-artikler/:id",
        loadComponent: () =>
            import("./routes/knowledge-article-id-page/knowledge-article-id-page.component").then((component) => component.KnowledgeArticleIdPageComponent),
        title: "Vidensartikel",
        canActivate: [AuthGuard]
    },

    {
        path: "kurser",
        loadComponent: () => import("./routes/courses-page/courses-page.component").then((component) => component.CoursesPageComponent),
        title: "Kurser",
        canActivate: [AuthGuard]
    },
    {
        path: "beskedcenter",
        loadComponent: () => import("./routes/message-archive-page/message-archive-page.component").then((component) => component.MessageArchivePageComponent),
        title: "Beskedcenter",
        canActivate: [AuthGuard]
    },
    {
        path: "**",
        component: ErrorPageComponent
    }
];
